import { sideTrackings, coverStory } from '@/mocks/homeNews';

export default function CoverHero() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-6 md:py-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <article className="lg:col-span-8 relative rounded-lg overflow-hidden min-h-[420px] md:min-h-[520px] flex">
            <div className="absolute inset-0 w-full h-full">
              <img
                src={coverStory.image}
                alt="陆星辰录音风波追踪封面"
                title="18黑料网 丑闻曝光 封面追踪"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-foreground-950/20" />
            <div className="relative z-10 mt-auto p-6 md:p-9 w-full">
              <div className="flex flex-wrap items-center gap-2 mb-4">
                <span className="inline-flex items-center gap-1.5 bg-primary-600 text-background-50 text-[12px] font-semibold px-3 py-1 rounded-full">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-fire-line text-[12px]" />
                  </span>
                  {coverStory.category}
                </span>
                <span className="inline-flex items-center gap-1.5 bg-background-50/15 border border-background-50/30 text-background-50 text-[12px] px-3 py-1 rounded-full backdrop-blur">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-time-line text-[12px]" />
                  </span>
                  {coverStory.day}
                </span>
              </div>
              <h2 className="font-heading text-[26px] md:text-[40px] font-bold leading-tight text-background-50 max-w-[720px]">
                {coverStory.title}
              </h2>
              <p className="mt-3 md:mt-4 text-[13px] md:text-[15px] leading-relaxed text-background-200 max-w-[640px]">
                {coverStory.excerpt}
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6">
                <a
                  href="#tracking"
                  className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-foreground-950 text-[13px] font-semibold px-5 py-2.5 rounded-md transition-colors whitespace-nowrap"
                >
                  查看完整脉络
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-[15px]" />
                  </span>
                </a>
                <div className="flex items-center gap-5 text-[12px] text-background-200">
                  <span className="flex items-center gap-1.5">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-fire-line text-[14px] text-primary-400" />
                    </span>
                    热度 {coverStory.heat}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-chat-3-line text-[14px] text-accent-400" />
                    </span>
                    {coverStory.comments} 条讨论
                  </span>
                  <span className="hidden sm:flex items-center gap-1.5">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-refresh-line text-[14px]" />
                    </span>
                    {coverStory.updated}
                  </span>
                </div>
              </div>
            </div>
          </article>

          <aside className="lg:col-span-4 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 flex flex-col">
            <div className="flex items-center justify-between pb-4 border-b border-background-300/60">
              <h3 className="font-heading text-[17px] font-bold text-foreground-950 flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-radar-line text-[16px] text-primary-600" />
                </span>
                正在追踪
              </h3>
              <span className="text-[12px] text-foreground-500">共 4 条线索</span>
            </div>
            <ul className="mt-4 flex flex-col gap-4">
              {sideTrackings.map((item, idx) => (
                <li key={item.title} className="flex gap-3">
                  <span className="flex items-center justify-center w-6 h-6 rounded-md bg-secondary-100 text-secondary-900 text-[12px] font-semibold shrink-0 mt-0.5">
                    {idx + 1}
                  </span>
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-[11px] font-semibold text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full">
                        {item.tag}
                      </span>
                      <span className="text-[11px] text-foreground-500">
                        <span className="w-3 h-3 inline-flex items-center justify-center align-middle">
                          <i className="ri-fire-line text-[11px]" />
                        </span>{' '}
                        {item.heat}
                      </span>
                    </div>
                    <a
                      href="#latest"
                      className="text-[14px] leading-snug text-foreground-900 hover:text-primary-700 transition-colors"
                    >
                      {item.title}
                    </a>
                  </div>
                </li>
              ))}
            </ul>
            <a
              href="#trending"
              className="mt-5 flex items-center justify-center gap-1.5 border border-background-300 text-foreground-800 hover:bg-background-200 text-[13px] font-medium py-2.5 rounded-md transition-colors whitespace-nowrap"
            >
              查看全部追踪线索
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-down-line text-[15px]" />
              </span>
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}